module.exports = __webpack_public_path__ + "static/media/icon.a52faacf.png";